<template>
  <div>
    <div class="blocks">
      <div class="l-m-b-20 align-items-center d-flex justify-content-between">
        <div class="col-8 d-flex align-items-center title-search">
          <h1 class="pr-3">Jobs</h1>
          <div class="input-group search">
            <button type="button" class="btn input-group-btn" @click="clearSearch">
              <i :class="[q ? 'fa fa-remove' : 'fa fa-search']" />
            </button>
            <input class="form-control search-input" type="text" v-model="q" @keydown="searchText($event)"
                   placeholder="Search"
            />
          </div>
        </div>
        <div class="col-2">
          <load-filter-dropdown
            @filterSelected="loadFilters"
            @filterTemplatesInitialized="setFilterTemplatesInitialized"
            :route="$route.name"
          />
        </div>
        <div class="col-2 text-right pr-0 mobile-hidden">
          <router-link tag="button" class="btn btn-primary btn-schedule" to="/schedule">
            <!-- <div class="mod-icon mod-icon-rates" />-->
            SCHEDULE
          </router-link>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center d-md-none">
        <div class="number-of-jobs" v-if="meta">
          {{ meta.to }} of {{ meta.total }} <span class="us-hidden">Jobs</span>
        </div>
        <div>
          <div class="col-12 text-right pr-0">
            <button class="btn btn-primary btn-schedule btn-refine" @click="showMobileFilters = true">
              <!-- <div class="mod-icon mod-icon-rates" />-->
              <span v-if="isActiveFilters || selectedKey" class="mobile-dot-refine-active-filters" />
              REFINE
            </button>
            <button class="btn btn-secondary expand-all" @click="toggleAllJobs">
              <i :class="[jobs && expandedAll ? 'fa fa-compress' : 'fa fa-expand']" />
            </button>
          </div>
        </div>
      </div>
      <div class="d-flex mobile-hidden justify-content-between">
        <div class="filters-field">
          <span>Filters:</span>
          <span v-if="filtersLoaded">
            <span v-if="filters.cash_collected" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('cash_collected')" />
              Cash collected: {{ filters.cash_collected === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.carrier.length && carriers">
              <span v-for="carrier in filters.carrier" :key="carrier" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('carrier', carrier)" />
                Carrier: {{ carriers.find(el => el.id === carrier).name }}</span>
            </span>
            <span v-if="filters.company.length && companies">
              <span v-for="company in filters.company" :key="company" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('company', company)" />
                Company: {{ companies.find(el => el.id === company).name }}</span>
            </span>
            <span v-if="filters.moveSize" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('moveSize')" />
              Move Size: {{ moveSizes.find(el => el.id === filters.moveSize).name }}</span>
            <span v-if="filters.move_date" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('move_date')" />
              Move Date: {{ filters.move_date }}</span>
            <span v-if="filters.created_at" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('created_at')" />
              Created At: {{ filters.created_at }}</span>
            <span v-if="filters.clusterUser.length && salesFilter.length">
              <span v-for="clusterUser in filters.clusterUser" :key="clusterUser" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('clusterUser', clusterUser)" />
                Sales: {{ salesFilter.find(el => el.id === clusterUser).full_name }}</span>
            </span>
            <span v-if="filters.recurlyPlan.length && plans.length">
              <span v-for="recurlyPlan in filters.recurlyPlan" :key="recurlyPlan" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('recurlyPlan', recurlyPlan)" />
                Plans: {{ plans.find(el => el.id === recurlyPlan).name }}</span>
            </span>
            <span v-if="filters.userCompanies && clusterUsersFilter.length" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('userCompanies')" />
              User companies: {{ clusterUsersFilter.find(el => el.id === filters.userCompanies).full_name }}</span>
            <span v-if="filters.status" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('status')" />
              Status: {{ jobStatuses.find(el => el.id === filters.status).name }}</span>
            <span v-if="filters.source" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('source')" />
              Source: {{ sources.find(el => el.id === filters.source).name }}</span>
            <span v-if="filters.leadSourceId" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('leadSourceId')" />
              Lead Source: {{ sources.find(el => el.id === filters.leadSourceId).name }}</span>
            <span v-if="filters.canceled === 'false'" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('canceled')" />
              Show Canceled: {{ filters.canceled === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.feeChange" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('feeChange')" />
              Fee Changes Required: {{ filters.feeChange === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.hasClaim" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('hasClaim')" />
              Has claim: {{ filters.hasClaim === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.hasHeavyItems" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('hasHeavyItems')" />
              Has heavy items: {{ filters.hasHeavyItems === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.hasSubscription" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('hasSubscription')" />
              Has subscription: {{ filters.hasSubscription === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.offers_sent" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('offers_sent')" />
              Offers sent: {{ filters.offers_sent === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.organic_bookings" class="filter-item btn btn-filter">
              <span class="mod-icon-filter" @click="removeFilter('organic_bookings')" />
              Organic bookings: {{ filters.organic_bookings === 'true' ? 'Yes' : 'No' }}</span>
            <span v-if="filters.tags && filters.tags.length && tags">
              <span v-for="tag in filters.tags" :key="tag" class="filter-item btn btn-filter">
                <span class="mod-icon-filter" @click="removeFilter('tags', tag)" />
                Tag: {{ tags.find(el => el.id === tag).name }} </span>
            </span>
          </span>
          <button class="btn btn-secondary add-filters" @click="showFilters = true">
            <i class="fa fa-plus filter-icon" />
          </button>
        </div>
        <div class="d-flex justify-content-end pr-0" style="min-width: 200px">
          <div class="dropdown">
            <button class="btn btn-secondary sort-button sort-button-selected" id="dropdownMenuButton"
                    data-toggle="dropdown" aria-haspopup="true"
                    aria-expanded="false"
            >
              <i v-if="selectedKey.length" class="fa pr-2"
                 :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']"
              />
              <span v-if="selectedKey === 'created_at'">
                Created at
              </span>
              <span v-else-if="selectedKey === 'move_date'">
                Move date
              </span>
              <span v-else>
                Sort by
              </span>
              <i class="fa fa-caret-down caret" />
            </button>
            <div class="dropdown-menu sort-dropdown dropdown-menu-right" aria-labelledby="dropdownMenuButton">
              <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('created_at')">
                <span :class="[selectedKey === 'created_at' ? 'selected' : '']">
                  Created date
                </span>
                <span>
                  <i v-if="selectedKey === 'created_at'" class="fa"
                     :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']"
                  />
                </span>
              </button>
              <button class="dropdown-item sort-dropdown-item nav-link btn" @click.stop="sortBy('move_date')">
                <span :class="[selectedKey === 'move_date' ? 'selected' : '']">
                  Move date
                </span>
                <span>
                  <i v-if="selectedKey === 'move_date'" class="fa"
                     :class="[ascOrDesc === 'asc' ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc']"
                  />
                </span>
              </button>
            </div>
          </div>
          <button class="btn btn-secondary expand-all" @click="toggleAllJobs">
            <i :class="[jobs && expandedAll ? 'fa fa-compress' : 'fa fa-expand']" />
          </button>
        </div>
      </div>
    </div>
    <template v-if="!jobs">
      <vue-content-loading :width="800" :height="450">
        <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
      </vue-content-loading>
    </template>
    <template v-else>
      <div class="blocks">
        <JobsBlock
          v-for="(job, index) in jobs"
          :key="index"
          :job.sync="job"
          :q.sync="q"
          :expanded="expanded"
          :job-loading="jobLoading"
          @job-updated="updateJob(jobs, index, $event)"
          @expanded="toggleJob"
          @setFiltersSaved="callSetFiltersSaved"
          @showModalAcceptJob="showModalAcceptJob = true"
        />
      </div>

      <div class="row blocks">
        <div class="col-md-6 mb-1 text-black-50 d-none d-md-block jobs-meta"
             v-if="meta.total"
        >
          Showing {{ meta.from }} - {{ meta.to }} of {{ meta.total }}
        </div>
        <pagination class="col-md-6 mb-1 jobs-pagination" :change-page="changePage" :meta="meta" />
      </div>
    </template>

    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showFilters" @click.self="showFilters = false">
        <div v-if="showFilters" class="filters-side-modal flex flex-column justify-content-between">
          <div @click="showFilters = !showFilters" class="pointer">
            <h1 class="modal-h1 l-m-b-20"><span class="btn btn-back" />Add Filter</h1>
          </div>
          <div>
            <p>
              Filters are applied automatically. You can remove them one by one with minus button or with clear filters
              button.
            </p>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12" v-if="companies && companies.length">
                    <div class="select-wrap">
                      <label>Company</label>
                      <key-multiselect v-model="filters.company"
                                       :options="companies"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'company-select'"
                                       :placeholder="'Select Company'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="carriers && carriers.length">
                    <div class="select-wrap">
                      <label>Carriers</label>
                      <key-multiselect v-model="filters.carrier"
                                       :options="carriers"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'carrier-select'"
                                       :placeholder="'Select Carrier'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move Size</label>
                      <simple-select v-model="filters.moveSize"
                                     :options="moveSizes"
                                     :input-id="'move-sizes-select'"
                                     placeholder="Select Move Size"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move date</label>
                      <flat-pickr v-model="filters.move_date"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Move Date"
                                  name="date"
                                  @on-close="onMoveDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearMoveDateAndSearch"
                            v-if="filters.move_date"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent" v-else><span
                        class="mod-icon-rates-dark"
                      /></span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Booked At</label>
                      <flat-pickr v-model="filters.created_at"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Booking Date"
                                  name="date"
                                  @on-close="onCreatedDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearCreatedDateAndSearch"
                            v-if="filters.created_at"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent" v-else><span
                        class="mod-icon-rates-dark"
                      /></span>
                    </div>
                  </div>
                  <div class="col-12" v-if="salesFilter && salesFilter.length">
                    <div class="select-wrap">
                      <label>Sales Rep.</label>
                      <key-multiselect v-model="filters.clusterUser"
                                       :options="salesFilter"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :id="'sales-select'"
                                       :placeholder="'Select Sales'"
                                       :preserve-search="false"
                                       label="full_name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.full_name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="plans && plans.length">
                    <div class="select-wrap">
                      <label>Recurly Plan</label>
                      <key-multiselect v-model="filters.recurlyPlan"
                                       :options="plans"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :id="'plans-select'"
                                       :placeholder="'Select Plan'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="clusterUsersFilter && clusterUsersFilter.length">
                    <div class="select-wrap">
                      <label>User companies</label>
                      <simple-select v-model="filters.userCompanies"
                                     :options="clusterUsersFilter"
                                     :input-id="'user-companies-select'"
                                     placeholder="Select User"
                                     @input="search"
                                     track-by="id"
                                     label="full_name"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Status</label>
                      <simple-select v-model="filters.status"
                                     :options="jobStatuses"
                                     :input-id="'status-select'"
                                     placeholder="Select Status"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Source</label>
                      <simple-select v-model="filters.source"
                                     :options="sources"
                                     :input-id="'source-select'"
                                     placeholder="Select Source"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Lead Source</label>
                      <simple-select v-model="filters.leadSourceId"
                                     :options="sources"
                                     :input-id="'source-select'"
                                     placeholder="Select Lead Source"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Show canceled</label>
                      <simple-select v-model="filters.canceled"
                                     :options="booleanOptions"
                                     :input-id="'canceled-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Fee Changes Required</label>
                      <simple-select v-model="filters.feeChange"
                                     :options="booleanOptions"
                                     :input-id="'fee-changes-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Has claim</label>
                      <simple-select v-model="filters.hasClaim"
                                     :options="booleanOptions"
                                     :input-id="'has-claim-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Has heavy items</label>
                      <simple-select v-model="filters.hasHeavyItems"
                                     :options="booleanOptions"
                                     :input-id="'has-heavy-items-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Has subscription</label>
                      <simple-select v-model="filters.hasSubscription"
                                     :options="booleanOptions"
                                     :input-id="'has-subscription-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Offers sent</label>
                      <simple-select v-model="filters.offers_sent"
                                     :options="booleanOptions"
                                     :input-id="'offers-sent-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Organic bookings</label>
                      <simple-select v-model="filters.organic_bookings"
                                     :options="booleanOptions"
                                     :input-id="'offers-organic_bookings-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div v-if="$_can('tags.show') && tags && tags.length" class="col-12">
                    <div class="select-wrap">
                      <label>Tags</label>
                      <key-multiselect
                        v-model="filters.tags"
                        :options="tags"
                        :multiple="true"
                        :clear-on-select="false"
                        :close-on-select="false"
                        track-by="id"
                        @input="search"
                        label="name"
                        class="w-100"
                      >
                        <template slot="tag" slot-scope="props">
                          <span class="multiselect__tag p-0 bg-transparent">
                            <span>
                              <tag-color
                                :color="props.option.color.name"
                                :name="props.option.name"
                              />
                            </span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <div class="d-flex align-items-center justify-content-between">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Cash collected</label>
                      <simple-select v-model="filters.cash_collected"
                                     :options="booleanOptions"
                                     :input-id="'has-subscription-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-auto">
            <div class="col">
              <button type="button" class="btn btn-not-active text-dark w-100" @click="clearFilters()"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Clear filters
              </button>
            </div>
            <div class="col">
              <button type="button" class="btn btn-primary text-white w-100" @click="saveFiltersModal = true"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Save filters
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <!-- Filters -->
    <transition name="slide-fade">
      <div class="l-modal-mask" v-if="showMobileFilters" @click.self="showMobileFilters = false">
        <div v-if="showMobileFilters" class="filters-side-modal flex flex-column mobile-modal">
          <div class="pointer">
            <h1 class="modal-h1 l-m-b-20">
              <span class="btn btn-back" @click="showMobileFilters = !showMobileFilters" />Apply
              sorting and filters
            </h1>
          </div>
          <div class="l-bg-white">
            <div class="row">
              <div class="col">
                <div class="row filters">
                  <div class="col-12">
                    <h5>Sort by</h5>
                    <div class="row mb-3">
                      <div class="col-6">
                        <span
                          :class="[selectedKey === 'created_at' ? 'text-primary' : 'text-secondary']"
                        >Created date</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <button class="btn"
                                    :class="[selectedKey === 'created_at' && ascOrDesc === 'asc' ? 'btn-active' : 'btn-not-active']"
                                    @click="triggerMobileSortBy('created_at', 'asc')"
                            >
                              <i class="fa text-dark" :class="['fa-sort-amount-asc']" />
                            </button>
                          </div>
                          <div class="input-group-append">
                            <button class="btn"
                                    :class="[selectedKey === 'created_at' && ascOrDesc === 'desc' ? 'btn-active' : 'btn-not-active']"
                                    @click="triggerMobileSortBy('created_at', 'desc')"
                            >
                              <i class="fa text-dark" :class="['fa-sort-amount-desc']" />
                            </button>
                          </div>
                        </div>
                      </div>
                      <div class="col-6">
                        <span
                          :class="[selectedKey === 'move_date' ? 'text-primary' : 'text-secondary']"
                        >Move date</span>
                        <div class="input-group">
                          <div class="input-group-prepend">
                            <button class="btn"
                                    :class="[selectedKey === 'move_date' && ascOrDesc === 'asc' ? 'btn-active' : 'btn-not-active']"
                                    @click="triggerMobileSortBy('move_date', 'asc')"
                            >
                              <i class="fa text-dark" :class="['fa-sort-amount-asc']" />
                            </button>
                          </div>
                          <div class="input-group-append">
                            <button class="btn"
                                    :class="[selectedKey === 'move_date' && ascOrDesc === 'desc' ? 'btn-active' : 'btn-not-active']"
                                    @click="triggerMobileSortBy('move_date', 'desc')"
                            >
                              <i class="fa text-dark" :class="['fa-sort-amount-desc']" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 mb-3 pt-3 border-top">
                    <h5>Filters</h5>
                  </div>
                  <div class="col-12" v-if="companies && companies.length">
                    <div class="select-wrap">
                      <label>Company</label>
                      <key-multiselect v-model="filters.company"
                                       :options="companies"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'company-select'"
                                       :placeholder="'Select Company'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="carriers && carriers.length">
                    <div class="select-wrap">
                      <label>Carriers</label>
                      <key-multiselect v-model="filters.carrier"
                                       :options="carriers"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :close-on-select="false"
                                       :hide-selected="true"
                                       :id="'carrier-select'"
                                       :placeholder="'Select Carrier'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move Size</label>
                      <simple-select v-model="filters.moveSize"
                                     :options="moveSizes"
                                     :input-id="'move-sizes-select'"
                                     placeholder="Select Move Size"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Move date</label>
                      <flat-pickr v-model="filters.move_date"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Move Date"
                                  name="date"
                                  @on-close="onMoveDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearMoveDateAndSearch"
                            v-if="filters.move_date"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent" v-else><span
                        class="mod-icon-rates-dark"
                      /></span>
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Booked At</label>
                      <flat-pickr v-model="filters.created_at"
                                  :config="config"
                                  class="simple-select-input"
                                  placeholder="Select Booking Date"
                                  name="date"
                                  @on-close="onCreatedDateChange"
                      />
                      <span class="position-absolute clear-date" @click="clearCreatedDateAndSearch"
                            v-if="filters.created_at"
                      >
                        <span class="mod-icon-clear" />
                        <span aria-hidden="true" class="sr-only">Clear</span>
                      </span>
                      <span class="position-absolute clear-date clear-date-transparent" v-else><span
                        class="mod-icon-rates-dark"
                      /></span>
                    </div>
                  </div>
                  <div class="col-12" v-if="salesFilter && salesFilter.length">
                    <div class="select-wrap">
                      <label>Sales Rep.</label>
                      <key-multiselect v-model="filters.clusterUser"
                                       :options="salesFilter"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :id="'sales-select'"
                                       :placeholder="'Select Sales'"
                                       :preserve-search="false"
                                       label="full_name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.full_name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="plans && plans.length">
                    <div class="select-wrap">
                      <label>Recurly Plan</label>
                      <key-multiselect v-model="filters.recurlyPlan"
                                       :options="plans"
                                       :multiple="true"
                                       :clear-on-select="false"
                                       :hide-selected="true"
                                       :id="'plan-select'"
                                       :placeholder="'Select Plan'"
                                       :preserve-search="false"
                                       label="name"
                                       track-by="id"
                                       @input="search"
                      >
                        <template slot="tag" slot-scope="props">
                          <div class="multiselect__tag">
                            <span>{{ props.option.name }}</span>
                            <span class="multiselect__tag-icon" @click="props.remove(props.option)" />
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                  <div class="col-12" v-if="clusterUsersFilter && clusterUsersFilter.length">
                    <div class="select-wrap">
                      <label>User companies</label>
                      <simple-select v-model="filters.userCompanies"
                                     :options="clusterUsersFilter"
                                     :input-id="'user-companies-select'"
                                     placeholder="Select User"
                                     @input="search"
                                     track-by="id"
                                     label="full_name"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Status</label>
                      <simple-select v-model="filters.status"
                                     :options="jobStatuses"
                                     :input-id="'status-select'"
                                     placeholder="Select Status"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Source</label>
                      <simple-select v-model="filters.source"
                                     :options="sources"
                                     :input-id="'source-select'"
                                     placeholder="Select Source"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Lead Source</label>
                      <simple-select v-model="filters.leadSourceId"
                                     :options="sources"
                                     :input-id="'source-select'"
                                     placeholder="Select Lead Source"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Show canceled</label>
                      <simple-select v-model="filters.canceled"
                                     :options="booleanOptions"
                                     :input-id="'canceled-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Fee Changes Required</label>
                      <simple-select v-model="filters.feeChange"
                                     :options="booleanOptions"
                                     :input-id="'fee-changes-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Has claim</label>
                      <simple-select v-model="filters.hasClaim"
                                     :options="booleanOptions"
                                     :input-id="'has-claim-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Has heavy items</label>
                      <simple-select v-model="filters.hasHeavyItems"
                                     :options="booleanOptions"
                                     :input-id="'has-heavy-items-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Has subscription</label>
                      <simple-select v-model="filters.hasSubscription"
                                     :options="booleanOptions"
                                     :input-id="'has-subscription-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Offers sent</label>
                      <simple-select v-model="filters.offers_sent"
                                     :options="booleanOptions"
                                     :input-id="'offers-sent-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div class="col-12">
                    <div class="select-wrap">
                      <label>Organic bookings</label>
                      <simple-select v-model="filters.organic_bookings"
                                     :options="booleanOptions"
                                     :input-id="'offers-organic_bookings-select'"
                                     placeholder="Select"
                                     @input="search"
                      />
                    </div>
                  </div>
                  <div v-if="$_can('tags.show')" class="col-12">
                    <div class="select-wrap">
                      <label>Tags</label>
                      <key-multiselect
                        v-model="filters.tags"
                        :options="tags"
                        :multiple="true"
                        :clear-on-select="false"
                        :close-on-select="false"
                        track-by="id"
                        @input="search"
                        label="name"
                        class="w-100"
                      >
                        <template slot="tag" slot-scope="props">
                          <span class="multiselect__tag p-0 bg-transparent">
                            <span>
                              <tag-color
                                :color="props.option.color.name"
                                :name="props.option.name"
                              />
                            </span>
                          </span>
                        </template>
                        <template slot="option" slot-scope="props">
                          <div class="option__desc">
                            <div class="d-flex align-items-center justify-content-between">
                              <span class="option__title">
                                {{ props.option.name }}
                              </span>
                            </div>
                          </div>
                        </template>
                      </key-multiselect>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-6">
              <button type="button" class="btn btn-not-active w-100" style="color: black" @click="clearFilters(true)"
                      :disabled="clearFiltersButtonShouldBeDisabled && !selectedKey"
              >
                Clear all
              </button>
            </div>
            <div class="col-6">
              <button type="button" class="btn btn-primary text-white w-100" @click="saveFiltersModal = true"
                      v-if="!clearFiltersButtonShouldBeDisabled"
              >
                Save filters
              </button>
            </div>
            <div class="col-12 pt-2">
              <button type="button" class="btn btn-primary w-100" @click="filter(); showMobileFilters = false;">
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- Save filters modal -->
    <SaveFiltersModal
      v-if="saveFiltersModal"
      @close="saveFiltersModal = false"
      :filters="filters"
      :route="$route.path"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import flatPickr from 'vue-flatpickr-component';
import axios from 'axios';
import Pagination from '../Pagination';
import JobsBlock from './JobsBlock';
import 'flatpickr/dist/flatpickr.css';
import TagColor from '../settings/Tags/TagColor';
import SaveFiltersModal from '../SaveFiltersModal.vue';
import LoadFilterDropdown from '../LoadFilterDropdown.vue';

export default {
  name: 'Jobs',
  components: {
    LoadFilterDropdown,
    SaveFiltersModal,
    TagColor,
    Pagination,
    flatPickr,
    JobsBlock,
  },
  data: () => ({
    showMobileFilters: false,
    expanded: [],
    filters: {
      balance: '',
      canceled: 'false',
      clusterUser: [],
      userCompanies: '',
      company: [],
      createdDateEnd: '',
      createdDateStart: '',
      created_at: '',
      carrier: [],
      leadSourceId: '',
      feeChange: '',
      hasClaim: '',
      hasHeavyItems: '',
      hasSubscription: '',
      moveDateEnd: '',
      moveDateStart: '',
      moveSize: '',
      move_date: '',
      offers_sent: '',
      recurlyPlan: [],
      sortKey: '',
      sortOrders: '',
      source: '',
      status: '',
      organic_bookings: '',
      tags: [],
      cash_collected: '',
    },
    filterTemplatesInitialized: false,
    hasDefaultFilterTemplate: true,
    selectedKey: '',
    timer: null,
    page: 1,
    q: '',
    config: {
      dateFormat: 'm/j/Y',
      mode: 'range',
    },
    booleanOptions: [
      {
        id: 'true',
        name: 'Yes',
      },
      {
        id: 'false',
        name: 'No',
      },
    ],
    saveFiltersModal: false,
    showFilters: false,
    showTooltipCancellationNote: [],
    expandedAll: false,
    jobLoading: false,
    tags: [],
  }),
  computed: {
    ...mapState({
      carriers: state => state.carriers.carriers.data,
      clusterUsersFilter: state => state.clusterUsers.clusterUsers,
      companies: state => state.companies.companies.data,
      filtersLoaded: state => state.guard.filtersLoaded,
      filtersSaved: state => state.filters.filtersSaved,
      jobStatuses: state => state.values.jobStatuses,
      jobs: state => state.jobs.jobs.data,
      meta: state => state.jobs.jobs.meta,
      moveSizes: state => state.values.moveSizes,
      plans: state => state.plans.plans,
      salesFilter: state => state.clusterUsers.salesFilter,
      sources: state => state.values.sources,
    }),
    ...mapGetters(['getJobsFiltered', 'getFiltersSaved']),
    /*    jobsWithoutCanceled() {
      if (this.filters.status !== 30) {
        return this.jobs.filter(job => job.status_id !== 30);
      }
      return this.jobs;
    }, */
    ascOrDesc() {
      return this.filters.sortOrders === 'asc' ? 'asc' : 'desc';
    },
    isActiveFilters() {
      return (
        this.filters.canceled ||
        this.filters.carrier.length ||
        this.filters.cash_collected ||
        this.filters.clusterUser.length ||
        this.filters.company.length ||
        this.filters.created_at ||
        this.filters.feeChange ||
        this.filters.hasClaim ||
        this.filters.hasHeavyItems ||
        this.filters.hasSubscription ||
        this.filters.leadSourceId ||
        this.filters.moveSize ||
        this.filters.move_date ||
        this.filters.offers_sent ||
        this.filters.organic_bookings ||
        this.filters.recurlyPlan.length ||
        this.filters.source ||
        this.filters.status ||
        this.filters.tags ||
        this.filters.userCompanies
      );
    },
    clearFiltersButtonShouldBeDisabled() {
      return (
        !this.filters.canceled &&
        !this.filters.carrier.length &&
        !this.filters.cash_collected &&
        !this.filters.clusterUser.length &&
        !this.filters.company.length &&
        !this.filters.created_at &&
        !this.filters.feeChange &&
        !this.filters.hasClaim &&
        !this.filters.hasHeavyItems &&
        !this.filters.hasSubscription &&
        !this.filters.leadSourceId &&
        !this.filters.moveSize &&
        !this.filters.move_date &&
        !this.filters.offers_sent &&
        !this.filters.organic_bookings &&
        !this.filters.recurlyPlan.length &&
        !this.filters.source &&
        !this.filters.status &&
        !this.filters.tags &&
        !this.filters.userCompanies
      );
    },
  },
  watch: {
    filterTemplatesInitialized() {
      if (!this.hasDefaultFilterTemplate) {
        if (this.filtersSaved && this.filtersSaved.previousPage === 'JobsEdit') {
          this.filters = { ...this.filtersSaved };
          this.page = this.filtersSaved.page;
        } else if (Object.keys(this.$route.query).length !== 0) {
          this.setFilters(this.$route.query);
        }
        this.filter();
      }
    },
    jobs() {
      if (this.expandedAll) {
        this.jobs.forEach(job => {
          this.expanded.push(job.id);
        });
      } else {
        this.expanded = [];
      }
    },
  },
  mounted() {
    this.getTags();
  },
  methods: {
    ...mapActions(['getJobs']),
    ...mapMutations(['setJobs', 'setFiltersSaved']),
    changePage(pageNum) {
      this.setJobs({});
      this.page = pageNum;
      this.filter();
    },
    updateJob(jobs, index, job) {
      this.$set(jobs, index, job);
    },
    getTags() {
      axios
        .get('/companies/tags/list?paginated=false')
        .then(res => {
          this.tags = res.data.data;
        })
        .catch(() => {});
    },
    loadFilters(filtersData) {
      this.filters = Object.assign(filtersData);
      this.filter();
    },
    setFilterTemplatesInitialized(hasDefault) {
      this.hasDefaultFilterTemplate = hasDefault;
      this.filterTemplatesInitialized = true;
    },
    setFilters(query) {
      this.filters = Object.assign(
        {
          balance: query.balance,
          canceled: query.canceled,
          closed: query.closed,
          clusterUser: query.cluster_user_id
            ? query.cluster_user_id.split(',').map(i => Number(i))
            : [],
          userCompanies: query.user_companies ? parseInt(query.user_companies, 10) : '',
          company: query.company_id ? query.company_id.split(',').map(i => Number(i)) : [],
          createdDateStart: query.created_from.toString(),
          createdDateEnd: query.created_to.toString(),
          created_at:
            query.created_from && query.created_to
              ? `${query.created_from.toString()} to ${query.created_from.toString()}`
              : '',
          carrier: query.carrier_id ? query.carrier_id.split(',').map(i => Number(i)) : [],
          feeChange: query.fee_change,
          hasClaim: query.has_claim,
          hasHeavyItems: query.has_heavy_items,
          hasSubscription: query.has_subscription,
          leadSourceId: query.lead_source_id ? parseInt(query.lead_source_id, 10) : '',
          moveDateStart: query.date_from.toString(),
          moveDateEnd: query.date_to.toString(),
          move_date:
            query.date_from && query.date_to
              ? `${query.date_from.toString()} to ${query.date_to.toString()}`
              : '',
          moveSize: query.move_size_id ? parseInt(query.move_size_id, 10) : '',
          offers_sent: query.offers_sent,
          organic_bookings: query.organic_bookings,
          recurlyPlan: query.recurly_plan_id
            ? query.recurly_plan_id.split(',').map(i => Number(i))
            : [],
          sortKey: query.sort,
          sortOrders: query.order,
          source: query.source_id ? parseInt(query.source_id, 10) : '',
          status: query.status_id ? parseInt(query.status_id, 10) : '',
          tags: query.tag_id ? query.tag_id.split(',').map(i => Number(i)) : [],
          cash_collected: query.cash_collected ? query.cash_collected : '',
        },
        {},
      );
      this.q = query.q.toString();
      this.page = query.page;
      this.selectedKey = this.filters.sortKey;
    },
    searchText(e) {
      // eslint-disable-next-line no-unused-expressions
      e.key;
      this.page = 1;
      const vm = this;
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        vm.filter();
      }, 500);
      // if (/^[a-zA-Z0-9]$/.test(e.key) || e.keyCode === 8 || e.keyCode === 13) {
      //   const vm = this;
      //   clearTimeout(this.timer);
      //   this.timer = setTimeout(() => {
      //     vm.filter();
      //   }, 500);
      // }
    },
    search() {
      this.page = 1;
      this.filter();
    },
    filter() {
      this.setJobs({});
      const query =
        `page=${this.page}&carrier_id=${this.filters.carrier}&company_id=${this.filters.company}` +
        `&move_size_id=${this.filters.moveSize}&date_from=${this.filters.moveDateStart}` +
        `&date_to=${this.filters.moveDateEnd}&created_from=${
          this.filters.createdDateStart
        }&created_to=${this.filters.createdDateEnd}&fee_change=${
          this.filters.feeChange
        }&has_claim=${this.filters.hasClaim}&has_heavy_items=${
          this.filters.hasHeavyItems
        }&has_subscription=${this.filters.hasSubscription}` +
        `&cluster_user_id=${this.filters.clusterUser}&recurly_plan_id=${
          this.filters.recurlyPlan
        }&user_companies=${this.filters.userCompanies}&status_id=${this.filters.status}&source_id=${
          this.filters.source
        }&lead_source_id=${this.filters.leadSourceId}&balance=${this.filters.balance}` +
        `&canceled=${this.filters.canceled ? this.filters.canceled : ''}&offers_sent=${
          this.filters.offers_sent
        }&organic_bookings=${this.filters.organic_bookings}&q=${encodeURIComponent(this.q)}&sort=${
          this.filters.sortKey
        }&order=${this.filters.sortOrders}&tag_id=${this.filters.tags}&cash_collected=${
          this.filters.cash_collected
        }`;
      this.getJobsFiltered(query);
      if (this.$_checkProperties(this.filters)) {
        this.$router.push(`/jobs?${query}`);
      } else {
        this.$router.push(`/jobs`);
      }
    },
    clearFilters(clearSortBy = false) {
      this.filters = Object.assign(
        {
          balance: '',
          canceled: '',
          carrier: [],
          clusterUser: [],
          company: [],
          createdDateEnd: '',
          createdDateStart: '',
          created_at: '',
          feeChange: '',
          hasClaim: '',
          hasHeavyItems: '',
          hasSubscription: '',
          leadSourceId: '',
          moveDateEnd: '',
          moveDateStart: '',
          moveSize: '',
          move_date: '',
          offers_sent: '',
          recurlyPlan: [],
          sortKey: '',
          sortOrders: '',
          source: '',
          status: '',
          tags: [],
          userCompanies: '',
        },
        {},
      );
      if (clearSortBy === true) {
        this.selectedKey = '';
        this.$set(this.filters, 'sortKey', '');
        this.$set(this.filters, 'sortOrders', '');
      }
      this.filter();
      this.showFilters = false;
      this.showMobileFilters = false;
    },
    clearSearch() {
      this.q = '';
      this.filter();
    },
    clearMoveDateAndSearch() {
      this.filters.move_date = '';
      this.filters.moveDateStart = '';
      this.filters.moveDateEnd = '';
      this.page = 1;
      this.filter();
    },
    clearCreatedDateAndSearch() {
      this.filters.created_at = '';
      this.filters.createdDateStart = '';
      this.filters.createdDateEnd = '';
      this.page = 1;
      this.filter();
    },
    sortBy(key) {
      this.selectedKey = key;
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters, 'sortOrders', this.filters.sortOrders === 'desc' ? 'asc' : 'desc');
      this.filter();
    },
    triggerMobileSortBy(key, ascOrDesc) {
      this.selectedKey = key;
      this.$set(this.filters, 'sortKey', key);
      this.$set(this.filters, 'sortOrders', ascOrDesc);
      this.filter();
    },
    onMoveDateChange(selectedDates) {
      this.filters.moveDateStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.moveDateEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.search();
    },
    onCreatedDateChange(selectedDates) {
      this.filters.createdDateStart = selectedDates[0]
        ? selectedDates[0].toLocaleDateString('en-US')
        : '';
      this.filters.createdDateEnd = selectedDates[1]
        ? selectedDates[1].toLocaleDateString('en-US')
        : '';
      this.search();
    },
    removeFilter(model, id) {
      if (id) {
        this.filters[model] = this.filters[model].filter(element => element !== id);
      } else {
        this.filters[model] = '';
      }
      if (model === 'move_date') {
        this.filters.moveDateStart = '';
        this.filters.moveDateEnd = '';
      }
      if (model === 'created_at') {
        this.filters.createdDateStart = '';
        this.filters.createdDateEnd = '';
      }
      this.search();
    },
    callSetFiltersSaved() {
      this.setFiltersSaved({ ...this.filters, previousPage: 'JobsEdit', page: this.page });
    },
    toggleJob(value) {
      if (this.expanded.includes(value)) {
        const index = this.expanded.indexOf(value);
        if (index > -1) {
          this.expanded.splice(index, 1);
        }
      } else {
        this.expanded.push(value);
      }
    },
    toggleAllJobs() {
      if (!this.expanded.length) {
        this.jobs.forEach(job => {
          this.expanded.push(job.id);
        });
        this.expandedAll = true;
      } else {
        this.expanded = [];
        this.expandedAll = false;
      }
    },
  },
};
</script>
<style scoped>
.btn-active:hover {
  -webkit-box-shadow: 0 2px 2px 0 rgba(22, 29, 37, 0.1), inset 0 1px 0 1px rgba(255, 255, 255, 0.06);
  box-shadow: 0 2px 2px 0 rgba(22, 29, 37, 0.1), inset 0 1px 0 1px rgba(255, 255, 255, 0.06);
  background-color: #0f47e2;
  border: solid 1px #0f47e2;
}

.btn-active {
  min-width: auto;
  min-height: 42px;
  border-radius: 4px;
  padding: 0.375rem 1rem;
  -webkit-box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.1), inset 0 1px 0 1px rgba(255, 255, 255, 0.06);
  box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.1), inset 0 1px 0 1px rgba(255, 255, 255, 0.06);
  background-color: #2962ff;
  border: solid 1px #0f47e2;
  font-size: 14px;
  font-weight: 500;
  line-height: 28px;
  letter-spacing: 0.4px;
  color: #ffffff;
}

.btn-active i {
  color: white !important;
}

.row.filters {
  height: 70vh;
  overflow-y: auto;
  margin-bottom: 10px;
}

.mobile-modal .filters {
  height: 75vh !important;
}

.search-input {
  min-width: 200px;
}

@media only screen and (min-width: 1000px) {
  .jobs-pagination {
    padding-right: 0;
  }

  .jobs-meta {
    padding-left: 0;
  }
}

@media only screen and (max-width: 490px) {
  .title-search {
    width: 100%;
  }

  .row.filters {
    height: 55vh;
  }
}

@media only screen and (max-width: 320px) {
  .us-hidden {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/Jobs.vue